import { Modal } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaArrowRight,
  FaClock,
  FaEnvelope,
  FaPhone,
  FaUser,
  FaFile,
  FaMobileScreen,
  FaBuilding,
} from "react-icons/fa6";
import { FaGlobeEurope } from "react-icons/fa";
import axios from "axios";
import moment from "moment";
import swal from "sweetalert";
import Loader from "../common/Loader";
import configure from "../../configure";

const RequestCallback = ({ btn_text, ClName }) => {
  const navigate = useNavigate();
  const [requestModal, setRequestModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [callBackDate, setCallBackDate] = useState("");
  const [callBackTime, setCallBackTime] = useState("");
  const [selectedService, setSelectedService] = useState("");
  const [company, setcompany] = useState("");

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(userEmail)) {
      swal("", "Invalid Email Address !", "warning");
      return;
    }
    if (userPhone.length < 10) {
      swal("", "Invalid Phone Number !", "warning");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("name", userName);
    formData.append("email", userEmail);
    formData.append("phone", userPhone);
    formData.append("services", selectedService);
    formData.append("date", moment(callBackDate).format("YYYY-MM-DD"));
    formData.append("time", callBackTime);
    formData.append("timezone", "Europe/London");
    formData.append("type", 25);
    formData.append("company", company);
    formData.append("enquiry_type", "callback");

    try {
      const response = await axios.post(
        `https://api.zithas.com/api/addBookings`,
        formData,
        {
          headers: {
            Accept: "appication/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("formdata", formData);

      if (response.data.success) {
        setLoading(false);
        setRequestModal(false);
        navigate("/construction/thankyou");
        setUserName("");
        setUserEmail("");
        setUserPhone("");
        setSelectedService("");
        setCallBackTime(null);
        setCallBackDate(null);
        console.log("req resp", response);
        console.log("resp formData", formData);
      }
    } catch (error) {
      setLoading(false);
      console.log("Error", error);
    }
  };

  return (
    <>
      {loading && <Loader />}

      {/* <button  onClick={() => setRequestModal(true)} className="button btn-red" >
                <FaPhone className="me-2" />
                <span> {btn_text} </span>
            </button> */}

      <button
        className="button btn-red mobileCTA"
        onClick={() => setRequestModal(true)}
      >
        <FaPhone className="me-2" />
        <span> {btn_text} </span>
      </button>

      {/* Add */}
      <Modal
        open={requestModal}
        title="Fill out the Details!"
        centered
        onCancel={() => {
          setRequestModal(false);
          setCallBackTime(null);
          setCallBackDate(null);
        }}
        width={450}
        footer={null}
      >
        <div className="bg-gradientt py-4 px-md-4 px-2 pb-5">
          <form
            onSubmit={handleFormSubmit}
            id="register-form"
            className="register-form register"
          >
            <div className="input-icon mb-3">
              <i>
                <FaUser />
              </i>
              <input
                className="form-control shadow-sm py-2 ps-5 pe-3 fs-6 lh-lg"
                required
                name="register_names"
                placeholder="Name*"
                type="text"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
              />
            </div>

            <div className="input-icon mb-3">
              <i>
                <FaEnvelope />
              </i>
              <input
                className="form-control shadow-sm py-2 ps-5 pe-3 fs-6 lh-lg"
                required
                name="register_email"
                placeholder="Email Adress*"
                type="email"
                value={userEmail}
                onChange={(e) => setUserEmail(e.target.value.toLowerCase())}
              />
            </div>
            <div className="input-icon mb-3">
              <i>
                <FaPhone />
              </i>
              <input
                className="form-control shadow-sm py-2 ps-5 pe-3 fs-6 lh-lg"
                required
                name="phone_number"
                placeholder="Phone Number*"
                type="number"
                value={userPhone}
                onChange={(e) => setUserPhone(e.target.value.slice(0, 12))}
              />
            </div>
            <div className="input-icon w-100 mb-3" id="callBackdatetime">
              <i>
                <FaClock />
              </i>
              <input
                className="form-control shadow-sm py-2 ps-5 pe-3 fs-6 lh-lg"
                placeholder="Preferable Time for Callback*"
                type="datetime-local"
                value={
                  callBackDate
                    ? moment(callBackDate).format("YYYY-MM-DD") +
                      "T" +
                      moment(callBackTime, "hh:mm A").format("HH:mm")
                    : ""
                }
                onChange={(e) => {
                  const selectedDateNTime = moment(e.target.value);
                  const selectedDate = selectedDateNTime.format("YYYY-MM-DD");
                  const selectedTime = selectedDateNTime.format("hh:mm A");
                  setCallBackDate(selectedDate);
                  setCallBackTime(selectedTime);
                }}
              />
            </div>
            <div className="input-icon mb-3">
              <i>
                <FaBuilding />
              </i>
              <input
                className="form-control shadow-sm py-2 ps-5 pe-3 fs-6 lh-lg"
                required
                name="register_email"
                placeholder="Company Name*"
                type="text"
                value={company}
                onChange={(e) => {
                  setcompany(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <select
                className="form-select shadow-sm py-2 ps-3 pe-5 fs-6 lh-lg"
                required
                value={selectedService}
                onChange={(e) => setSelectedService(e.target.value)}
              >
                <option value="">Select Service</option>
                <option value="47">Website Development</option>
                <option value="48">Mobile Application Development</option>
                <option value="49">Document Management System</option>
              </select>
            </div>

            <button
              id="modalSubmit"
              className="button btn-red mt-3 w-100"
              type="submit"
            >
              Request Now
              <FaArrowRight className="ms-3" />
            </button>
          </form>
        </div>
      </Modal>
    </>
  );
};
export default RequestCallback;
